import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as yup from 'yup';
import { Formik } from 'formik';
import Typography from '@mui/material/Typography';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { closePopup } from '../../actions/uiActions';
import { sendEmail } from '../../actions/userActions';
import CloseIcon from '@mui/icons-material/Close';

class DemoPopup extends React.Component {

    state = {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        company: "",
        message: "",
    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    handleSubmit = (event) => {
        event.preventDefault()
        this.props.sendEmail(this.state.firstName, this.state.lastName, this.state.email, this.state.phoneNumber, this.state.company, this.state.message)
    }

    changeInput = (string, event) => {
        event.preventDefault()
        this.setState({ [string]: event.target.value })
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={this.handleClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <CloseIcon onClick={this.handleClick} className="closePoup" />
                <DialogTitle id="alert-dialog-title" className="changepassdialog">
                    Demo Request Form
            </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Formik
                            initialValues={{
                                Firstname: '',
                                Lastname: '',
                                email: '',
                                phoneno: '',
                                company: '',
                                message: ''
                            }}
                            validationSchema={yup.object().shape({
                                Firstname: yup.string().required('Required'),
                                Lastname: yup.string().required('Required'),
                                email: yup
                                    .string()
                                    .email('Enter valid email')
                                    .required('Required'),
                                phoneno: yup
                                    .string()
                                    .matches(
                                        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
                                        'Phone number is not valid'
                                    )
                                    .min(
                                        10,
                                        'phone no must be greater than or equal to 10 digits'
                                    )
                                    .required('Required'),
                                message: yup.string().required('Required')
                            })}
                        >
                            {({
                                values,
                                handleChange,
                                errors,
                                setFieldTouched,
                                touched
                            }) => (
                                <form>
                                    <div className="requiredContact">
                                        <div className="myInputOut">
                                            <input
                                                type="text"
                                                name="Firstname"
                                                placeholder="First Name"
                                                value={values.Firstname}
                                                onChange={handleChange('Firstname')}
                                                onBlur={() => setFieldTouched('Firstname')}
                                                onChangeCapture={(event) => this.changeInput("firstName", event)}
                                                className="myInput"
                                            />
                                            {errors.Firstname && touched.Firstname && (
                                                <Typography style={{ fontSize: 15, color: 'red' }}>
                                                    {errors.Firstname}
                                                </Typography>
                                            )}
                                        </div>
                                        <div className="myInputOut">
                                            <input
                                                type="text"
                                                name="Lastname"
                                                placeholder="Last Name"
                                                value={values.Lastname}
                                                onChange={handleChange('Lastname')}
                                                onBlur={() => setFieldTouched('Lastname')}
                                                onChangeCapture={(event) => this.changeInput("lastName", event)}
                                                className="myInput"
                                            />
                                            {errors.Lastname && touched.Lastname && (
                                                <Typography style={{ fontSize: 15, color: 'red' }}>
                                                    {errors.Lastname}
                                                </Typography>
                                            )}
                                        </div>
                                        <div className="myInputOut">
                                            <input
                                                type="text"
                                                name="email"
                                                placeholder="Email"
                                                value={values.email}
                                                onChange={handleChange('email')}
                                                onBlur={() => setFieldTouched('email')}
                                                onChangeCapture={(event) => this.changeInput("email", event)}
                                                className="myInput"
                                            />
                                            {errors.email && touched.email && (
                                                <Typography style={{ fontSize: 15, color: 'red' }}>
                                                    {errors.email}
                                                </Typography>
                                            )}
                                        </div>
                                        <div className="myInputOut">
                                            <input
                                                type="text"
                                                className="myInput"
                                                name="phoneno"
                                                placeholder="Phone Number"
                                                value={values.phoneno}
                                                onChange={handleChange('phoneno')}
                                                onBlur={() => setFieldTouched('phoneno')}
                                                onChangeCapture={(event) => this.changeInput("phoneNumber", event)}
                                            />
                                            {errors.phoneno && touched.phoneno && (
                                                <Typography style={{ fontSize: 15, color: 'red' }}>
                                                    {errors.phoneno}
                                                </Typography>
                                            )}
                                        </div>
                                        <div className="myInputOut">
                                            <input
                                                type="text"
                                                name="company"
                                                placeholder="Company"
                                                value={values.company}
                                                onChange={handleChange('company')}
                                                onChangeCapture={(event) => this.changeInput("company", event)}
                                                className="myInput"
                                            />
                                        </div>
                                        <div className="myInputOut">
                                            <TextareaAutosize
                                                aria-label="empty textarea"
                                                placeholder="Message"
                                                className="myInputText Requesttext"
                                                value={values.message}
                                                onChange={handleChange('message')}
                                                onBlur={() => setFieldTouched('message')}
                                                onChangeCapture={(event) => this.changeInput("message", event)}
                                            />
                                            {errors.message && touched.message && (
                                                <Typography style={{ fontSize: 15, color: 'red' }}>
                                                    {errors.message}
                                                </Typography>
                                            )}
                                        </div>
                                        <div className="bigButtonOut">
                                            <button
                                                type="submit"
                                                className="btn"
                                                onClick={(e) => this.handleSubmit(e)}
                                            >
                                                Submit
                          </button>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, sendEmail }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DemoPopup)